import superagent from 'superagent';
import { backendUrl } from '../../../helpers/consts';

export async function fetchAmazonConfigs(maskSecrets = true) {
  try {
    const response = await superagent
      .get(`${backendUrl}/amazon-configs`)
      .query({ maskSecrets })
      .set('Authorization', `Bearer ${localStorage.getItem('authJWT')}`);
    return response.body.data || [];
  } catch (error) {
    console.error('Failed to fetch amazon configs:', error);
    throw error;
  }
}

export async function fetchAmazonConfigDetails(storeKey, maskSecrets = true) {
  try {
    const response = await superagent
      .get(`${backendUrl}/amazon-configs/${storeKey}`)
      .query({ maskSecrets })
      .set('Authorization', `Bearer ${localStorage.getItem('authJWT')}`);
    return response.body.data;
  } catch (error) {
    console.error('Failed to fetch amazon config details:', error);
    throw error;
  }
}

export async function createAmazonConfig(configData) {
  try {
    const response = await superagent
      .post(`${backendUrl}/amazon-configs`)
      .set('Authorization', `Bearer ${localStorage.getItem('authJWT')}`)
      .set('Content-Type', 'application/json')
      .send(configData);
    
    return response.body;
  } catch (error) {
    console.error('Failed to create amazon config:', error);
    throw error;
  }
}

export async function deleteAmazonConfig(storeKey) {
  try {
    const response = await superagent
      .delete(`${backendUrl}/amazon-configs/${storeKey}`)
      .set('Authorization', `Bearer ${localStorage.getItem('authJWT')}`);
    
    return response.body;
  } catch (error) {
    console.error('Failed to delete amazon config:', error);
    throw error;
  }
}

export async function updateMarketplaceDisplayNames(id, marketplaces) {
  try {
    const response = await superagent
      .patch(`${backendUrl}/amazon-configs/${id}/marketplaces/display-names`)
      .set('Authorization', `Bearer ${localStorage.getItem('authJWT')}`)
      .set('Content-Type', 'application/json')
      .send({ marketplaces });
    
    return response.body;
  } catch (error) {
    console.error('Failed to update marketplace display names:', error);
    throw error;
  }
}
